import { InfoNote } from "@/shared/components/InfoNote/InfoNote";

import style from "./style.module.css";

const DEFAULT_INTRO_TEXT = "Use this form to create a new assessment template.";

interface TemplateFormIntroProps {
  notes: string[];
  introText?: string;
}

export function TemplateFormIntro({ notes, introText = DEFAULT_INTRO_TEXT }: TemplateFormIntroProps) {
  return (
    <>
      <div className={style.formIntro}>
        <p>{introText}</p>
        <p>
          Fill out all the required fields and submit to generate the template. Any errors will be flagged for review.
        </p>
      </div>

      <InfoNote items={notes} />
    </>
  );
}
